module.exports = __webpack_public_path__ + "img/selected3-min.5f967d83.png";